import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@ant-design/icons';
import { Button } from 'antd';
import { AcastPlus } from '../../../utils/ExtraSvg';
import config from '../../../config';

const AcastPlusButton = ({ providerShowId }) => {
  return (
    <Button
      type="primary"
      icon={<Icon component={AcastPlus} style={{ fill: '#fff' }} />}
      href={`${config.acastPlusManagerAppUrl}/shows/${providerShowId}`}
    >
      Acast+
    </Button>
  );
};

AcastPlusButton.propTypes = {
  providerShowId: PropTypes.string,
};

export default AcastPlusButton;
